import _ from 'lodash/fp'
import { all, call, put, take, takeLatest } from 'redux-saga/effects'

import { types as graphicsElementsTypes, actions as graphicsElementsActions } from '../reducers/graphicsElements'
import { getEffect } from './network'

//  ███████╗███████╗███████╗███████╗ ██████╗████████╗███████╗
//  ██╔════╝██╔════╝██╔════╝██╔════╝██╔════╝╚══██╔══╝██╔════╝
//  █████╗  █████╗  █████╗  █████╗  ██║        ██║   ███████╗
//  ██╔══╝  ██╔══╝  ██╔══╝  ██╔══╝  ██║        ██║   ╚════██║
//  ███████╗██║     ██║     ███████╗╚██████╗   ██║   ███████║
//  ╚══════╝╚═╝     ╚═╝     ╚══════╝ ╚═════╝   ╚═╝   ╚══════╝

export function * getGraphicsElements () {
  const url = `graphics/elements-for-edit`
  const request = {
    url
  }
  const chan = yield call(getEffect, request)
  return yield take(chan)
}

//  ███████╗ █████╗  ██████╗  █████╗ ███████╗
//  ██╔════╝██╔══██╗██╔════╝ ██╔══██╗██╔════╝
//  ███████╗███████║██║  ███╗███████║███████╗
//  ╚════██║██╔══██║██║   ██║██╔══██║╚════██║
//  ███████║██║  ██║╚██████╔╝██║  ██║███████║
//  ╚══════╝╚═╝  ╚═╝ ╚═════╝ ╚═╝  ╚═╝╚══════╝

function * loadGraphicsElementsFlow () {
  const graphicsElements = yield call(getGraphicsElements)
  const error = _.get('error', graphicsElements)
  if (error) {
    yield put(graphicsElementsActions.getElementsFailure(error))
  } else {
    yield put(graphicsElementsActions.getElementsSuccess(graphicsElements))
  }
}

export default function * () {
  return yield all([
    takeLatest(graphicsElementsTypes.GET_ELEMENTS, loadGraphicsElementsFlow)
  ])
}
